// services/customerRemittanceService.js

import API_BASE from "../config/api";

export const fetchCustomerRemittance = async (from, to) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Customer/RemittanceList?from=${from}&to=${to}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch customer remittance");
  }

  return await response.json();
};